import {
  readHexInt,
  readProtocolReversedHexScaled,
  readScaledHex
} from "./hex";
import { getProtocolString } from "./source";

// 运行状态帧：设备标识(2) + 水温(4) + 故障(4) + 保养(4) +
// 水箱液位(2) + 预留(2) + IO 输入(4) 后，紧跟 4 位 IO 输出。
const IO_OUTPUT_START = 22;

// 《标准机 http 协议 pro》IO 输出位（XLSRO / XLSNF / 250SM）。
const IO_OUTPUT_MASKS = {
  totalInletValve: 0x0001,
  inletValve: 0x0002,
  concentrateValve: 0x0004,
  rawWaterPump: 0x0100,
  highPressurePump: 0x0200,
  supplyPump: 0x0400
};

// 页面按设备现场约定，将第 14、15 项映射为原水、纯水累计量；
// 两项均按协议示例的字符逆序规则换算。
const CUMULATIVE_WATER_STARTS = {
  rawWaterTotal: 26,
  pureWaterTotal: 34
};

export function parseDeviceSwitches(protocol) {
  const output = readHexInt(
    getProtocolString(protocol, "runningState"),
    IO_OUTPUT_START,
    4
  );

  return {
    totalInletValve: (output & IO_OUTPUT_MASKS.totalInletValve) !== 0,
    inletValve: (output & IO_OUTPUT_MASKS.inletValve) !== 0,
    concentrateValve: (output & IO_OUTPUT_MASKS.concentrateValve) !== 0,
    rawWaterPump: (output & IO_OUTPUT_MASKS.rawWaterPump) !== 0,
    highPressurePump: (output & IO_OUTPUT_MASKS.highPressurePump) !== 0,
    supplyPump: (output & IO_OUTPUT_MASKS.supplyPump) !== 0
  };
}

export function parseRuntimeMetrics(protocol) {
  const parameters = getProtocolString(protocol, "runParameters");
  const runningState = getProtocolString(protocol, "runningState");

  return {
    temperature: readScaledHex(runningState, 2, 4, 10, 1),
    inletPressure: readScaledHex(parameters, 8, 2, 100, 2),
    inletFlow: readScaledHex(parameters, 80, 4, 100, 2),
    membranePressure: readScaledHex(parameters, 16, 2, 100, 2),
    pureWaterFlow: readScaledHex(parameters, 84, 4, 100, 2),
    supplyPressure: readScaledHex(parameters, 24, 2, 100, 2),
    supplyFlow: readScaledHex(parameters, 42, 4, 100, 2),
    rawWaterTotal: readProtocolReversedHexScaled(
      parameters,
      CUMULATIVE_WATER_STARTS.rawWaterTotal,
      8,
      1000,
      3
    ),
    pureWaterTotal: readProtocolReversedHexScaled(
      parameters,
      CUMULATIVE_WATER_STARTS.pureWaterTotal,
      8,
      1000,
      3
    )
  };
}
